import {mountExperience} from './wimpire-nextgen_landing_faae7eeb6c-app-hero-510f337b.js';
// A section can be replaced without a page reload in the Shopify editor.
const mounted = new Map();
function rootsWithin(node) {
  const roots = [...(node.querySelectorAll?.('[data-wimpire-experience]') || [])];
  if (node.matches?.('[data-wimpire-experience]')) roots.unshift(node);
  return roots;
}
function mount(root) {
  if (mounted.has(root)) return;
  if (root.dataset.wimpireModule && new URL(root.dataset.wimpireModule,location.href).href !== import.meta.url) return;
  const cleanup = mountExperience(root);
  mounted.set(root, typeof cleanup === 'function' ? cleanup : () => {});
}
function unmount(root) { mounted.get(root)?.(); mounted.delete(root); }
export function mountAll(node = document) { rootsWithin(node).forEach(mount); }
mountAll();
document.addEventListener('shopify:section:load', event => mountAll(event.target));
document.addEventListener('shopify:section:unload', event => rootsWithin(event.target).forEach(unmount));
addEventListener('pagehide', () => [...mounted.keys()].forEach(unmount));
addEventListener('pageshow', () => mountAll());
